module.exports = __webpack_public_path__ + "img/together.de9571ee.png";